import { createContext, useContext, useState, useEffect } from "react";
import { sendEmailVerification } from "firebase/auth";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";
import { auth } from "./Firebase";

export async function acceptUser(userCredential, navigate, provider, name, b2bInfo = null) {
  const user = userCredential.user;
  const service_provider = provider;
  if (user) {
    if (!user.emailVerified) {
      // Create the settings object --this will redirect the user to account page after verification
      const actionCodeSettings = {
        url: 'https://www.mytalemaker.com/account?verified=true',
        handleCodeInApp: false
      };
      
      // Pass it to sendEmailVerification
      await sendEmailVerification(user, actionCodeSettings);
    }
    const idToken = user["accessToken"];
    const displayName = name ? name : user.displayName ? user.displayName : "";
    console.log("AcceptUser - name:", displayName);
    const info = {
      emailAdd: user["email"],
      name: displayName,
      createdAt: user["metadata"]["creationTime"],
      lastLogin: user["metadata"]["lastSignInTime"],
      emailVerified: user["emailVerified"],
      provider: service_provider,
      userType: "regular"
    };

    // Add organization info if present
    if (b2bInfo) {
      info.accountType = b2bInfo.accountType;
      info.userType = b2bInfo.userType ;
      info.userRole = b2bInfo.userRole;
      
      // Only add organization details if they exist
      if (b2bInfo.organizationInfo) {
        info.organizationInfo = b2bInfo.organizationInfo;
      }
    }

    console.log("AcceptUser - info:", info);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND}/user/usersInfo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken,
        },
        body: JSON.stringify(info),
      }
    );
    if (!response.ok) {
      // Parse the error response
      const errorData = await response.json();
       // Create and throw a proper Error object
       const error = new Error(errorData.error || "Error during signup process");
       // Add status as a property of the error
       error.status = response.status;
       throw error;
     }else {
      console.log("Successfully sent info to backend");
    }

    navigate("/account");
  } else {
    console.log("not a user!");
  }
}

export async function redirectSignIn(navigate) {
  if (window.sessionStorage.getItem("AuthPending")) {
    window.sessionStorage.removeItem("AuthPending");
    // show spinner
    try{
    const result = await getRedirectResult(auth);
    console.log("sign in result", result);
    // hide spinner
    
      if (result){
      const provider = "Google";
      console.log("signup page provider", provider, result.user.displayName);
      await acceptUser(result, navigate, provider, result.user.displayName);
      }
    } catch (error) {
      console.log("Sign in error with google", error);
      window.location.reload(); // Add this to reset state if error occurs
    }
  }
}

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const [user, setUser] = useState({});

  async function signUp(email, password, name) {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
   
    return userCredential;
  }

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logOut() {
    return signOut(auth);
  }

  function passwordResetEmail(email) {
    return sendPasswordResetEmail(auth, email);
  }

  async function googleSignIn() {
    window.sessionStorage.setItem("AuthPending", 1);
    const googleAuthProvider = new GoogleAuthProvider();
    signInWithRedirect(auth, googleAuthProvider);

  }

  useEffect(() => {
    //const user = auth.currentUser;
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      // console.log("Auth", user)
    });
    return () => {
      unsubscribe();
      //console.log("Auth2", user)
    };
  }, []);

  return (
    <userAuthContext.Provider
      value={{
        user,
        signUp,
        logIn,
        logOut,
        passwordResetEmail,
        googleSignIn,
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function UseUserAuth() {
  return useContext(userAuthContext);
}
